export const storeLastVisitedSection = (sectionId, pageName) => {
  const key = `lastVisitedSection_${pageName}`;
  sessionStorage.setItem(key, sectionId);
};

export const getLastVisitedSection = (pageName) => {
  const key = `lastVisitedSection_${pageName}`;
  return sessionStorage.getItem(key);
};

export const clearLastVisitedSection = (pageName) => {
  const key = `lastVisitedSection_${pageName}`;
  sessionStorage.removeItem(key);
};
